import React, { useMemo } from 'react';
import TimeField from 'react-simple-timefield';
import { ELSIcon, ELSTextBox } from '@els/els-component-form-field-react';
import ELSTextarea from 'components/common/textarea/ELSTextarea';
import { FieldType, MarAdministerFormField } from './MarAdministerSidebar';

interface MarAdministerTextboxProps {
  formFieldItem: MarAdministerFormField | FieldType;
  onChange: Function;
  onBlur?: Function;
  isDisabled?: boolean;
  labelVertical?: boolean;
  placeholder?: string;
  showCheckmark?: boolean;
}

const MarAdministerTextbox = ({ formFieldItem, onChange, onBlur, isDisabled, labelVertical = false, placeholder, showCheckmark = false }: MarAdministerTextboxProps) => {
  const displayPassedIcon = useMemo(
    () => showCheckmark && !isDisabled && formFieldItem.isTouched && !formFieldItem.error,
    [showCheckmark, isDisabled, formFieldItem.isTouched, formFieldItem.error]
  );
  const renderInput = () => {
    switch (formFieldItem.type) {
      case 'text':
        return (
          <ELSTextBox
            cssClasses={`chart-input__textbox chart-input__input--pull-right ${formFieldItem.error ? 'error-form-field' : ''}`}
            value={formFieldItem.value}
            changeHandler={onChange}
            blurHandler={onBlur}
            isDisabled={isDisabled}
            placeholder={placeholder}
          />
        );
      case 'time':
        return (
          <TimeField
            className="c-els-field__input"
            value={formFieldItem.value}
            onChange={(_e, validatedValue) => onChange(validatedValue, formFieldItem)}
            style={{ width: '100%' }}
          />
        );
      case 'area':
        return (
          <div className="area-input">
            <ELSTextarea
              name="chart-comments-textarea"
              className="chart-comments__textarea u-els-margin-top-1o2"
              rows={3}
              value={formFieldItem.value}
              onChange={(e) => onChange(e, formFieldItem)}
              onBlur={(e) => onBlur && onBlur(e, formFieldItem)}
              isDisabled={isDisabled}
              style={{ width: '100%' }}
            />
            <p className="notes">(Administration Notes, Dose Given, etc.)</p>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="mar-administer-sidebar__container__bar-code">
      <div className={`input-wrapper ${labelVertical ? 'label-vertical' : ''}`}>
        <div className={`label ${isDisabled ? 'disabled' : ''}`}>
          {formFieldItem.isRequired && (showCheckmark || !formFieldItem.value || !formFieldItem.isTouched) && <span className="chart-input__label-asterisk">* </span>}
          <span className="chart-input__label">{formFieldItem.label}</span>
        </div>
        <div className="input">
          {renderInput()}
          {displayPassedIcon && <ELSIcon name="confirmation-solid-circle" size="1x" color="confirm" customClass="passed" />}
        </div>
        {formFieldItem.error && (
          <div className="mar-administer-sidebar__container__bar-code__error">
            <div className="error-icon">
              <ELSIcon name="alert-solid-square" size="1x" color="warn" customClass="error-icon" />
            </div>
            {formFieldItem.error}
          </div>
        )}
      </div>
    </div>
  );
};

export default MarAdministerTextbox;
